import { auditFormService } from '#apps/client-web/features/audit-form/services/audit-form';
import { fileStorageService } from '#apps/client-web/features/file-storage/services/file-storage';
import { ReactQueryClientService } from '#apps/client-web/app/services/react-query-client';
import { useLogger } from '#apps/client-web/app/hooks/use-logger';
import { FormPageLayout } from '#apps/client-web/app/components/form-page-layout';

import { CenteredLayout } from '#packages/web/foundations/layouts/centered-layout';

import { AuditFormMechanicalEntryPageMenu } from './audit-form-mechanical-entry-page-menu';
import { AuditFormMechanicalEntryPageContainer } from './audit-form-mechanical-entry-page.container';
import { useAuditFormMechanicalEntryPageViewModel } from './audit-form-mechanical-entry-page.view-model';

export const AuditFormMechanicalEntryPage = () => {
  const logger = useLogger('pages/audit-form-mechanical-entry');

  const viewModel = useAuditFormMechanicalEntryPageViewModel({
    auditFormService,
    fileStorageService,
    queryClient: ReactQueryClientService.offlineQueryClient,
    logger,
  });

  const { mainMenu, isDeleteDisabled, onDelete } = viewModel;

  return (
    <FormPageLayout
      title="Mechanical"
      isFormChanged={viewModel.form.formState.isDirty}
      onSubmit={viewModel.onSubmit}
      isSubmitDisabled={viewModel.updateMutationState.state === 'pending'}
      headerChildren={
        viewModel.loadAuditFormState.state === 'success' && (
          <AuditFormMechanicalEntryPageMenu
            /* Menu state */
            onClose={mainMenu.close}
            onOpen={mainMenu.open}
            isOpen={mainMenu.isOpen}
            anchorEl={mainMenu.anchorEl}
            /* Menu actions */
            onDelete={onDelete.bind(null, { confirmed: false })}
            isDeleteDisabled={isDeleteDisabled}
          />
        )
      }>
      <CenteredLayout horizontal>
        <AuditFormMechanicalEntryPageContainer viewModel={viewModel} />
      </CenteredLayout>
    </FormPageLayout>
  );
};
